import { Injectable } from '@angular/core';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import * as signalR from '@microsoft/signalr';
import { OirAuthService } from '../../services/auth/oir-auth.service';
import { ConfigurationService, IAppSettings } from '../../services/configuration/configuration.service';
import { ConcurrentAccessService, ConcurrentUser } from './concurrent-access.service';

@Injectable({ providedIn: 'root' })
export class ConcurrentAccessChannel {
  private connection: signalR.HubConnection;

  constructor(
    private configuration: ConfigurationService<IAppSettings>,
    private auth: OirAuthService,
    private concurrentAccessService: ConcurrentAccessService
  ) { }

  private connectionSetup(): Promise<void> {
    return forkJoin([
      this.configuration.get('CommsEndpoint'),
      this.auth.getAccessToken({requestUrl: 'CommsEndpoint'}),
      this.configuration.get('UserName')
    ])
      .pipe(
        map(([apiEndpoint, token, userName]) => {
          const url = window.location.href.replace('#', '');
          this.connection = new signalR.HubConnectionBuilder()
            .withUrl(
              `${apiEndpoint.url}core/userAccessHub?userName=${userName}&resourceId=${url}`,
              {
                accessTokenFactory: () => token,
                withCredentials: false
              }
            )
            .withAutomaticReconnect()
            .build();
        })
      ).toPromise().then(() => console.log('Hub Connection done!'));
  }

  async start(): Promise<void> {
    if (!this.connection) {
      await this.connectionSetup();
    }
    if (this.connection.state == signalR.HubConnectionState.Disconnected) {
      this.connection
        .start()
        .then(() => {
          console.log('Started: listening setConcurrentUsers...');

          this.connection.on('setConcurrentUsers', (users: ConcurrentUser[]) => {
            console.log('setConcurrentUsers received...', users);
            this.concurrentAccessService.setUserCount(users);
          });
        })
        .catch(err => console.log('Error while starting connection: ' + err));
    }
  }

  stop(): void {
    if (this.connection.state == signalR.HubConnectionState.Connected) {
      this.connection
        .stop()
        .then(() => {
          console.log('Stoped: unsubscribing setConcurrentUsers...');
          this.connection.off('setConcurrentUsers');
        })
        .catch(err => console.log('Error while stoping connection: ' + err));
    }
  }
}
